/* generated using openapi-typescript-codegen -- do no edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { samlKeyOrOrg } from '../models/samlKeyOrOrg'
import type { SamlTenantResource } from '../models/SamlTenantResource'
import type { TenantWrite } from '../models/TenantWrite'

import type { CancelablePromise } from '../core/CancelablePromise'
import type { BaseHttpRequest } from '../core/BaseHttpRequest'

export class SsoSamlTenantsService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}

    /**
     * List tenants for given organization or key.
     * Requires either key or org in query string.
     * @returns any OK
     * @throws ApiError
     */
    public getTenants({
        key,
        org
    }: {
        /**
         * Required if org not provided
         */
        key?: 'helm'
        /**
         * Organization ID. Required if key not provided
         */
        org?: number
    }): CancelablePromise<{
        data: Array<SamlTenantResource>
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/saml2/tenant',
            query: {
                key: key,
                org: org
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Create new tenant
     * @returns any Created
     * @throws ApiError
     */
    public createTenant({ requestBody }: { requestBody?: samlKeyOrOrg & TenantWrite }): CancelablePromise<{
        data: SamlTenantResource
    }> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/saml2/tenant',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`
            }
        })
    }

    /**
     * Show a single tenant
     * @returns any OK
     * @throws ApiError
     */
    public getTenant({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<{
        data: SamlTenantResource
    }> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/saml2/tenant/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Delete a tenant
     * @returns void
     * @throws ApiError
     */
    public deleteTenant({
        id
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
    }): CancelablePromise<void> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/saml2/tenant/{id}',
            path: {
                id: id
            },
            errors: {
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }

    /**
     * Update a tenant
     * @returns any OK
     * @throws ApiError
     */
    public updateTenant({
        id,
        requestBody
    }: {
        /**
         * ID of the retrieved resource.
         */
        id: number
        requestBody?: TenantWrite
    }): CancelablePromise<{
        data: SamlTenantResource
    }> {
        return this.httpRequest.request({
            method: 'PATCH',
            url: '/saml2/tenant/{id}',
            path: {
                id: id
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad request`,
                401: `User is unauthorized.`,
                403: `Access Denied`,
                404: `Not Found`
            }
        })
    }
}
